import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_LOCALE,
  buildPathWithLocale,
  detectBrowserLocale,
  getLocaleFromPathname,
  getStoredLocale,
  setStoredLocale,
} from '../locales/languages';

const useLocaleDetection = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const url = new URL(window.location.href);
    const pathLocale = getLocaleFromPathname(url.pathname);
    const stored = getStoredLocale();
    const detected = detectBrowserLocale();

    const nextLocale = pathLocale || stored || detected || DEFAULT_LOCALE;

    if (i18n.language !== nextLocale) {
      i18n.changeLanguage(nextLocale);
    }
    setStoredLocale(nextLocale);

    const nextPathname = buildPathWithLocale(url.pathname, nextLocale);
    if (url.pathname !== nextPathname) {
      url.pathname = nextPathname;
    }

    const nextUrl = url.toString();
    if (nextUrl !== window.location.href) {
      window.history.replaceState({}, '', nextUrl);
    }
  }, [i18n]);
};

export default useLocaleDetection;
